<template>
  <div class="uk-width-1-4@l uk-width-2-3@m uk-width-2-3@s uk-width-3-4">
    <table class="uk-table">
      <tbody>
        <tr>
          <td class="uk-text-bold uk-padding-remove-top uk-padding-remove-left">
            {{ modePriceLabel }}
          </td>
          <td class="uk-text-right@l uk-text-bold uk-padding-remove-top">
            {{ item.formatedSalepriceMerchantGross }} €
            <!--
            <template v-if="showEndcustomerPrices"> {{ item.saleprice | euro }} </template>
            <template v-if="showMerchantPrices"> {{ item.saleprice | euro }} </template>
            <template v-if="mode == 'merchant'"> {{ item.saleprice | euro }} </template>
            -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['item'],

  computed: {
    ...mapGetters(['mode', 'modePriceLabel', 'showEndcustomerPrices', 'showMerchantPrices'])
  }
}
</script>
